import { useCallback, useMemo } from "react";

import { hideEndOfIgAccountName } from "koljobs-helpers";

import { useSubscriberAuth } from "@/features/businessSubscription/hooks/useSubscriberAuth";
import CrownIcon from "@/icons/crown.svg";

type ModelIGProps = {
  instagram: string;
};

export const ModelIG = ({ instagram }: ModelIGProps) => {
  const { isSubscriber, subscriberCall } = useSubscriberAuth();

  const trimmedIGName = useMemo(() => instagram.trim(), [instagram]);

  const handleInstagramClick = useCallback(() => {
    subscriberCall(() => {
      window
        .open(`https://www.instagram.com/${trimmedIGName}/`, "_blank")
        .focus();

      return;
    });
  }, [subscriberCall, trimmedIGName]);

  return (
    <div className="flex items-center gap-1">
      <CrownIcon height={18} width={18} />
      <a
        className="text-primary cursor-pointer"
        onClick={handleInstagramClick}
        target="_blank"
        rel="noreferrer"
      >{`@${
        isSubscriber ? trimmedIGName : hideEndOfIgAccountName(trimmedIGName)
      }`}</a>
    </div>
  );
};
